(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('.klaviyo-star-rating-widget');
      if (!trigger) return;

      // Stop default anchor jump + other handlers
      e.preventDefault();
      e.stopPropagation();

      const target = document.querySelector('#klaviyo-product-reviews-wrapper');
      const header = document.querySelector('#SiteHeader');

      if (!target) return;

      const headerHeight = header ? header.offsetHeight : 0;

      const targetPosition =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        headerHeight;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });

    }, true); // 👈 IMPORTANT: use capture phase
  });
})();